var _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniArrowToRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4,
    x2: 12,
    y2: 4,
    stroke: "#D91F05"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3,
    y1: 0.6,
    x2: 12.3,
    y2: 3.6,
    stroke: "#D91F05"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.64645,
    y1: 7.64645,
    x2: 12.6464,
    y2: 3.64645,
    stroke: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniArrowToRight);
export default __webpack_public_path__ + "static/media/mini_arrow_to_right.466dda53404c8a42d544819c74ea2cd8.svg";
export { ForwardRef as ReactComponent };